import { apiPost } from "./client.ts";

// (TF3-3) the legacy whole-script edit and regenerate are retired (the backend answers 410); an engine video's script
//  is approved at its run's gate, or edited beat by beat (EngineReview).
export const scriptsApi = {
  approve: (videoId: string) =>
    apiPost<{ ok: boolean }>(`/videos/${videoId}/script/approve`),

  /** Approve script AND skip settings — go straight to storyboard generation. */
  approveAndGenerate: (videoId: string) =>
    apiPost<{ ok: boolean }>(`/videos/${videoId}/script/approve-and-generate`),
};
